"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getBookingAppearance = getBookingAppearance;
exports.getBookingTagStatus = getBookingTagStatus;
exports.sortedBookings = sortedBookings;
exports.sortedPastBookings = sortedPastBookings;
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _constants = require("../constants");
function getBookingAppearance(displayStatus) {
  const isCancelled = displayStatus === _constants.ALL_PRODUCT_BOOKING_STATUS.CANCELLED_NOT_REFUNDED || displayStatus === _constants.ALL_PRODUCT_BOOKING_STATUS.CANCELLED_REFUNDED;
  const isPending = displayStatus === _constants.ALL_PRODUCT_BOOKING_STATUS.PENDING_PAYMENT;
  if (isCancelled) {
    return _constants.BOOKING_APPEARANCE.CANCELLED;
  }
  if (isPending) {
    return _constants.BOOKING_APPEARANCE.PENDING;
  }
  return _constants.BOOKING_APPEARANCE.CONFIRMED;
}
function getBookingTagStatus(displayStatus) {
  if (_constants.ALL_PRODUCT_BOOKING_STATUS.IN_PROGRESS === displayStatus) {
    return _constants.BOOKING_STATUS.IN_PROGRESS;
  }
  if (_constants.ALL_PRODUCT_BOOKING_STATUS.CONFIRMED === displayStatus) {
    return _constants.BOOKING_STATUS.CONFIRMED;
  }
  if (_constants.ALL_PRODUCT_BOOKING_STATUS.CONFIRMED_PENDING_PAYMENT === displayStatus) {
    return _constants.BOOKING_STATUS.CONFIRMED_PENDING_PAYMENT;
  }
  if (_constants.ALL_PRODUCT_BOOKING_STATUS.NOT_CONFIRMED === displayStatus) {
    return _constants.BOOKING_STATUS.NOT_CONFIRMED;
  }
  if (_constants.ALL_PRODUCT_BOOKING_STATUS.PENDING_PAYMENT === displayStatus) {
    return _constants.BOOKING_STATUS.PENDING_PAYMENT;
  }
  if (_constants.ALL_PRODUCT_BOOKING_STATUS.CANCELLED_NOT_REFUNDED === displayStatus) {
    return _constants.BOOKING_STATUS.CANCELLED_NOT_REFUNDED;
  }
  if (_constants.ALL_PRODUCT_BOOKING_STATUS.CANCELLED_REFUNDED === displayStatus) {
    return _constants.BOOKING_STATUS.CANCELLED_REFUNDED;
  }
  if (_constants.ALL_PRODUCT_BOOKING_STATUS.CANCELLED === displayStatus) {
    return _constants.BOOKING_STATUS.CANCELLED;
  }
  if (_constants.ALL_PRODUCT_BOOKING_STATUS.COMPLETED === displayStatus) {
    return _constants.BOOKING_STATUS.COMPLETED;
  }
  if (_constants.ALL_PRODUCT_BOOKING_STATUS.UN_MAPPED === displayStatus) {
    return _constants.BOOKING_STATUS.UN_MAPPED;
  }
  return '';
}
function sortedBookings(data) {
  const sortedData = (0, _sortBy2.default)(data, item => {
    return _constants.SORTEDBOOKING.indexOf(item.displayStatus);
  });
  return sortedData;
}
function sortedPastBookings(data) {
  const filterPendingStatus = data.filter(item => item.displayStatus === _constants.ALL_PRODUCT_BOOKING_STATUS.PENDING_PAYMENT);
  const filterNotPendingStatus = data.filter(item => item.displayStatus !== _constants.ALL_PRODUCT_BOOKING_STATUS.PENDING_PAYMENT);
  return [...filterPendingStatus, ...filterNotPendingStatus];
}